import {observable, action, makeObservable} from "mobx";

class SitesStore {
    sites = undefined;
    siteById = {};
    site_analytics = {};
    site_analytics_v2 = {};
    site_trending = {};
    site_analytics_lite = {};
    site_hour_reports = {}
    site_invoice_reports = {}
    site_subscriptions = {}
    site_content = {}
    site_content_article = {}
    site_submissions = {}
    site_billing_portal = {}

    constructor() {
        makeObservable(this, {
            sites: observable,
            site_hour_reports: observable,
            site_invoice_reports: observable,
            site_subscriptions: observable,
            site_analytics: observable,
            site_analytics_v2: observable,
            site_trending: observable,
            site_analytics_lite: observable,
            site_submissions: observable,
            site_content: observable,
            site_content_article: observable,
            site_billing_portal: observable,

            setSites: action,
            setSiteHourReport: action,
            setSiteInvoiceReport: action,
            setSiteSubscriptionReport: action,
            setSiteSubmissions: action,
            setSiteContent: action,
            setSiteContentArticle: action,
            setSiteAnalytics: action,
            setSiteAnalyticsV2: action,
            setSiteAnalyticsLite: action,
            setSiteTrending: action,
            setSiteBillingPortal: action
        })
    }

    initialize() {
        this.sites = undefined;
        this.siteById = {};
        this.site_analytics = {};
        this.site_analytics_v2 = {};
        this.site_analytics_lite = {};
        this.site_hour_reports = {};
        this.site_invoice_reports = {};
        this.site_subscriptions = {};
        this.site_submissions = {};
        this.site_content = {};
        this.site_content_article = {};
    }

    setSites(sites) {
        this.sites = sites;
    }

    setSite(site) {
        if (!site || !site.site_id) return;
        this.siteById[site.site_id] = site;
        if (this.sites) {
            this.sites = this.sites.map(s => s.site_id === site.site_id ? site : s);
        } else {
            this.sites = [site];
        }
    }

    setSiteAnalytics(site_id, analytics) {
        if (!site_id || !analytics) return
        this.site_analytics[site_id] = analytics;
    }

    setSiteAnalyticsV2(site_id, analytics, date_range) {
        if (!site_id || !analytics) return
        if (this.site_analytics_v2[site_id]) {
            this.site_analytics_v2[site_id][date_range] = analytics;
        } else {
            this.site_analytics_v2[site_id] = { [date_range]: analytics }
        }
    }

    setSiteTrending(site_id, trending, date_range) {
        if (!site_id || !trending) return
        if (this.site_trending[site_id]) {
            this.site_trending[site_id][date_range] = trending;
        } else {
            this.site_trending[site_id] = { [date_range]: trending }
        }
    }

    setSiteHourReport(site_id, time_key, hour_report) {
        if (!site_id || !hour_report) return
        if (this.site_hour_reports[site_id]) {
            this.site_hour_reports[site_id][time_key] = hour_report;
        } else {
            this.site_hour_reports[site_id] = { [time_key]: hour_report }
        }
    }

    setSiteInvoiceReport(site_id, invoice_report) {
        if (!site_id || !invoice_report) return
        this.site_invoice_reports[site_id] = invoice_report;
    }

    setSiteSubscriptionReport(site_id, subscription) {
        if (!site_id || !subscription) return
        this.site_subscriptions[site_id] = subscription;
    }

    setSiteSubmissions(site_id, submissions) {
        if (!site_id || !submissions) return;
        this.site_submissions[site_id] = submissions;
    }

    setSiteContent(site_id, content) {
        if (!site_id || !content) return;
        this.site_content[site_id] = content;
    }

    setSiteContentArticle(tracking_id, article) {
        if (!tracking_id || !article) return;
        this.site_content_article[tracking_id] = article;
    }

    setSiteAnalyticsLite(site_id, analytics, date_range) {
        if (!site_id || !analytics) return
        if (this.site_analytics_lite[site_id]) {
            this.site_analytics_lite[site_id][date_range] = analytics;
        } else {
            this.site_analytics_lite[site_id] = { [date_range]: analytics }
        }
    }

    setSiteBillingPortal(site_id, portal_link) {
        if (!site_id || !portal_link) return
        this.site_billing_portal[site_id] = portal_link;
    }
};

/* makeObservable(SitesStore, {
    sites: observable,
    site_hour_reports: observable,
    site_invoice_reports: observable,
    site_subscriptions: observable,

    setSites: action,
    setSiteHourReport: action,
    setSiteInvoiceReport: action,
    setSiteSubscriptionReport: action,
}); */

export default new SitesStore();
